<template>
  <v-dialog v-model="dialog" width="800px">
    <v-form>
      <v-card>
        <v-card-title class="card-panel teal lighten-2">
          {{ form.contacttID ? 'Редактирование компании' : 'Новая компания' }}
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-col cols="4">
              <v-text-field
                v-model.trim="form.companyName"
                autofocus
                prepend-icon="mdi-account-circle-outline"
                placeholder="Наименование"/>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model.trim="form.contactMName"
                placeholder="Отчество"/>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model.trim="form.contactLName"
                placeholder="Фамилия"/>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model.trim="form.contactEmail"
                prepend-icon="mdi-mail"
                placeholder="E-mail"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model.trim="form.contactPhone"
                type="tel"
                prepend-icon="mdi-phone"
                placeholder="Телефон"
                v-mask="'+380 XX XXX-XX-XX'"
              />
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            raised
            @click="hide()">Отмена</v-btn>
          <v-btn
            raised
            color="primary"
            :loading="loading"
            @click="submitAction">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import { mask } from 'vue-the-mask'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import api from '@/api'

export default {
  mixins: [ validationMixin ],
  directives: {
    mask,
  },
  data: () => ({
    dialog: false,
    loading: false,
    form: {}
  }),
  validations: {
    form: {
      contactFName: { required }
    }
  },
  methods: {
    create () {
      this.form = {}
      this.dialog = true
    },
    edit (data) {
      this.form = Object.assign({}, data)
      this.dialog = true
    },
    hide () {
      this.dialog = false
    },
    submitAction() {
      if ( this.$v.$invalid ) return
      this.loadingForm = true
      api.post('companies/'+(this.form.contactID ? 'update/'+this.form.contactID : 'create'), this.form).then(response => {
        this.loadingForm = false
        if ( response.data.$result !== 'ok' ) return alert(response.data.data)
        this.dialog = false
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>
